import { Route } from 'react-router-dom';
import ProtectedRoute from 'shared/routes/Protected-Route';
import LegacyTenantPathRedirect from 'shared/routes/LegacyTenantPathRedirect';
import ContractPage from './pages/ContractPage';

/** Contract (222) — /{tenantName}/contract */
export const contractRoutes = (
  <>
    <Route path="/:tenantKey/contract" element={<ProtectedRoute element={<ContractPage />} />} />
    <Route path="/contract" element={<LegacyTenantPathRedirect />} />
  </>
);

export default contractRoutes;
